/* tslint:disable:max-line-length */
export const L10N_SK = {
  format_date: 'D.M.YYYY',
  format_date_placeholder: 'deň.mesiac.rok',

  validation_required: 'Vyplňte prosím políčko {0}.',
  validation_requiredThis: 'Vyplňte prosím toto políčko.',
  validation_email: 'Hodnota políčka {0} nie je platným emailom.',
  validation_date: 'Hodnota nie je platným dátumom. Platný formát: 15.2.1984',
  validation_captchaRequired: 'Kliknite prosím do bieleho štvorčeku. Kontrola slúži pre odfiltrovanie softvérových robotov.',
  validation_captchaInvalid: 'Neodpísali ste správne text z obrázku. Skúste to znovu prosím.',
  validation_duplicateRegistration: 'Na daný program ste už prihlásení. Vyberte si prosím iný.',
  validation_birthdateYear: 'Zadajte prosím platný rok narodenia',

  app_error_entityValidation: 'Ukladané dáta neprešli validáciou.',
  app_error_entityNotFound: 'Požadovaný záznam nebol nájdený.',
  app_error_db_insertFailed: 'Pri vkladaní údajov do databázi nastala chyba.',
  app_error_db_updateFailed: 'Pri aktualizácii údajov v databázi nastala chyba.',
  app_error_db_deleteFailed: 'Pri mazaní záznamu z databázi nastala chyba. Asi sa naň odkazujú iné záznamy.',
  app_error_internalServerError: 'Pri spracovávání požiadavky nastala chyba.',

  app_page_title: 'Prihlasovanie na programy',

  error_otEventRegistrationDisabled: 'Ospravedlňujeme sa, ale na tento program sa nedá prihlasovať.',
  error_otEventIsFull: 'Ospravedlňujeme sa, tento program je už zaplnený a nedá sa naň prihlasovať.',

  warning: 'Upozornenie',
  error: 'Chyba',

  menu_otEvents: 'Jednorázové akcie',
  menu_price: 'Cena',
  menu_person: 'Osoba',
  menu_locations: 'Miesta',
  menu_summary: 'Súhrn',
  menu_success: 'Prihláška vytvorená',

  dayOfWeek_0: 'Pondelok',
  dayOfWeek_1: 'Utorok',
  dayOfWeek_2: 'Streda',
  dayOfWeek_3: 'Štvrtok',
  dayOfWeek_4: 'Piatok',
  dayOfWeek_5: 'Sobota',
  dayOfWeek_6: 'Nedeľa',

  region_entity: 'Región',

  person_lastName: 'Priezvisko',
  person_firstName: 'Meno',
  person_fullName: 'Meno',
  person_birthdate: 'Dátum narodenia',
  person_birthdateYear: 'Rok narodenia',
  person_email: 'Email',
  person_telephone: 'Telefón',
  person_street: 'Ulica a číslo',
  person_city: 'Mesto',
  person_zipCode: 'PSČ',
  person_country: 'Štát',
  person_address: 'Adresa',

  personAddress_showFields: 'Chcem vyplniť svoju adresu',
  personAddress_street: 'Ulica',
  personAddress_city: 'Mesto',
  personAddress_postcode: 'PSČ',
  personAddress_country: 'Štát',

  course_dayOfWeek: 'Deň',
  course_timeFromTo: 'Čas',
  course_courseTags: 'Typ kurzu',
  course_description: 'Popis',
  course_venue: 'Miesto konania',
  course_room: 'Miestnosť',
  course_teacher: 'Cvičiteľ',
  course_price: 'Cena',
  course_: '',
  course_organization: 'Organizácia',
  course_timePeriod: 'Časové obdobie',

  otEvent_name: 'Názov',
  otEvent_startDate: 'Dátum',
  otEvent_dayOfWeek: 'Deň',
  otEvent_timeFromTo: 'Čas',
  otEvent_description: 'Popis',
  otEvent_venue: 'Miesto konania',
  otEvent_room: 'Miestnosť',
  otEvent_teacher: 'Vedúci',
  otEvent_organization: 'Organizácia',

  city_name: 'Mesto',
  city_happeningCount: 'Počet programov',

  happening_occupancy: 'Zaplnenosť',

  registration_notes: 'Vaše poznámky k prihláške',
  registration_informationSourceAnswer: 'Kde ste sa dozvedeli o kurzoch',
  registration_registrationReasonAnswers: 'Váš dôvod záujmu o kurz',
  registration_price: 'Cena prihlášky',
  registration_discounts: 'Zľavy',
  registration_premiums: 'Príplatky',
  registration_discountsAndPremiums: 'Zľavy a príplatky',
  registration_selectedOtEvent: 'Vybraný program',
  registration_pricingInfo: 'Cena prihlášky',
  registration_paymentTypeConfig: 'Spôsob platby',

  registrationReasonAnswer_custom: 'Iný dôvod',
  registrationReasonAnswer_custom_placeholder: 'Uveďte prosím svoj dôvod',

  button_select: 'Vybrať',
  button_ok: 'OK',

  breadcrumb_city: 'Výber mesta',
  breadcrumb_season: 'Výber obdobia',
  breadcrumb_course: 'Výber kurzu',
  breadcrumb_personalData: 'Osobné údaje',
  breadcrumb_startNewRegistration: 'Vytvoriť novú prihlášku',
  breadcrumb_summary: 'Súhrn',

  captcha: 'Overenie proti robotom',
  captcha_invalid: 'Zadaná hodnota overenia nebola platná',

  organization_paymentNotes: 'Informácie k platbe',

  personalData_title: 'Údaje o Vás',
  personalData_info: 'Vaše osobné údaje nebudú zneužité ani nikde publikované. Potrebujeme ich len pre evidenciu osôb.',
  personalData_currentAddress: 'Korešpodenčná adresa',
  personalData_agreeWithPersonalDataProcessing: 'Beriem na vedomie informáciu o spracovaní osobných údajov',
  personalData_personalDataProcessing_required: 'Je potrebné vyjadriť súhlas so spracovaním osobných údajov.',
  personalData_personalDataProcessing_label: 'Spracovanie osobných údajov',
  personalData_showAgreement: 'Zobraziť znenie',
  personalData_paymentNotes: 'Informácie k platbe',
  personalData_agreeWithTermsAndConditions: 'Súhlasím s obchodnými podmienkami',
  personalData_termsAndConditionsConsent_required: 'Je potrebné vyjadriť súhlas s obchodnými podmienkami.',
  personalData_showTermsAndConditions: 'Zobraziť podmienky',
  personalData_goToSummary: 'Prejsť na súhrn',
  personalData_newsSubscriber: 'Želám si dostávať novinky na email',
  personalData_firstName_placeholder: 'napr. Ľudmila',
  personalData_lastName_placeholder: 'napr. Veselá',
  personalData_nameFormat_info: 'Uveďte prosím mená s mäkčeňmi, dĺžňami, správnou veľkosťou písmen a bez titulov',
  personalData_address_info: 'Svoju adresu vyplňte ak ju potrebujete na daňovom doklade (napr. pre pojisťovňu)',
  personalData_paymentRedirect_title: 'Presmerovanie',
  personalData_paymentRedirect_info: 'Budete presmerovaní na platobnú bránu {0}',
  personalData_questionsByEmailInfo: 'Ak máte otázky alebo pripomienky, napíšte nám ich prosím na email {0}',

  summary_paymentType: 'Spôsob platby',
  summary_paymentType_bank: 'prevodom na účet',
  summary_paymentType_trustPay: 'kartou',
  summary_payment_qrCode_desc: 'Tento kód môžete naskenovať mobilnou aplikáciou vašej banky a tá vám predvyplní platobný formulár všetkými potrebnými údajmi.',

  paymentType_bank: 'Prevodom na účet',
  paymentType_bank_info: 'Platobné údaje vám budú zobrazené v nasledujúcom kroku a budú tiež zaslané na váš email, ktorý uvediete nižšie.',
  paymentType_card: 'Platba kartou (Visa, MasterCard)',
  paymentType_card_info: 'Po dokončení registrácie budete presmerovaní na platobnú bránu, umožňujúcu platbu kartou.',

  paymentGateway_trustPay: 'TrustPay',

  price_title: 'Cena',
  price_socialDiscount: 'Zľava pre ',
  price_chooseSocialGroup: 'Vyberte prosím svoju skupinu',
  price_validation_chooseSocialGroup: 'Pre uplatnenie tejto zľavy je potrebné vybrať skupinu',
  price_lateRegDiscountInfo: 'Z dôvodu, že kurz už prebieha, cena bola znížená',
  price_premiums: 'Voľby za príplatok',
  price_discounts: 'Zľavy',
  price_basicPrice: 'Základná cena',
  price_totalPrice: 'Celková cena',
  price_paymentType_title: 'Spôsob platby',
  price_goToPersonInfo: 'Prejsť osobné údaje',
  price_selectPaymentType: 'Vyberte prosím spôsob platby',

  finishing_title: 'Dokončenie registrácie',
  finishing_serverError: 'Nepodarilo sa vytvoriť vašu prihlášku z dôvodu chyby na serveri. Skúste to prosím neskôr, alebo nás kontaktujte emailom na adrese {0}. Ospravedlňujeme sa za komplikáciu.',

  success_title: 'Registrácia bola úspešne dokončená',
  success_thanks: 'Ďakujeme za vytvorenie prihlášky',
  success_emailSent: 'Nížšie uvedené informácie Vám prídu aj emailom na adresu {0}.',
  success_emailSent_spanNotice: 'Ak by Vám email neprišiel, skontrolujte si prosím zložku s nevyžiadanou poštou.',
  success_emailSendingError: 'Pri odosielaní potvrzujúceho emailu (na {0}) s nižšie uvedenými informáciami nastala chyba, ale vaša prihláška je platná. Odpíšte si prosím tu uvedené platobné informácie.',

  error_title: 'Chyba aplikácie',
  error_generic_desc: 'Pri komunikácii so serverom nastala chyba. Skúste prosím operáciu znovu, alebo nás kontaktujte emailom na adrese {0}. Ospravedlňujeme sa za komplikáciu.',
  error_goTo: 'Prejsť na',
  error_homepage: 'úvodnú stránku',

  registration_error_creatingPerson: 'Chyba pri vytváraní záznamu o osobe.',
  registration_error_updatingPerson: 'Chyba pri aktualizácii záznamu o osobe.',
  registration_error_saving: 'Chyba pri ukladaní prihlášky do databázi.',
  registration_error_creating: 'Chyba pri vytváraní prihlášky.',
  registration_error_precedingRegNotFound: 'Ak ste navštevovali kurz v predchádzajúcom období, kontaktujte nás prosím emailom na adrese {0}.',
  registration_onlyPrecedingSeasonParticipants: 'Na toto cvičebné obdobie sa môžu prihlasovať ešte len cvičenci, ktorí navštevovali kurz počas predchádzajúceho cvičebného obdobia "{0}", aby mali možnosť navštevovať naväzujúci kurz. Ostatní záujemci budú mať možnosť sa přihlásiť neskôr. Ďakujeme za pochopenie.',
  registration_followUpOnly: 'Prihlasovanie je povolené len pre cvičencov bežiacich kurzov.',
  registration_change: 'zmeniť',
  registration_informationSource_customText: 'iný zdroj (možnosť zadať ručne)',
  registration_informationSource_customText_placeholder: 'Uveďte prosím zdroj',

  summary_title: 'Sumarizácia',
  summary_registration_number: 'Číslo prihlášky',
  summary_registration_price: 'Cena prihlášky',
  summary_registration_basicPrice: 'Základná cena kurzu',

  summary_payment: 'Platobné informácie',
  summary_payment_bank_deadline: 'Platbu je nutné uskutočniť do dátumu uvedeného v registračnom emaili, ktorý vám bol zaslaný, inak bude vaša prihláška neplatná.',
  summary_payment_bank_sendTo: 'Platbu za kurz preveďte prosím na účet:',
  summary_payment_bank_bankName: 'Názov banky',
  summary_payment_bank_accountNumber: 'Číslo účtu',
  summary_payment_bank_iban: 'IBAN',
  summary_payment_bank_variableSymbol: 'Variabilný symbol',
  summary_payment_bank_specificSymbol: 'Špecifický symbol',
  summary_payment_notes: 'Poznámky k platbe',
  summary_successfullyPayed: 'Vaša prihláška bola úspešne zaplatená.',

  summary_selectedCourse: 'Zvolený kurz',

  result_error_title: 'Chyba pri vykonávaní platby',
  result_error_info: 'Počas platby sa vyskytla chyba. Môžete to skúsiť znovu alebo zmeniť typ platby alebo prihlášku stornovať.',

  result_cancel_title: 'Plaba za prihlášku bola stornovaná',
  result_cancel_info: 'Ak ste stornovali platbu kvôli nevyhovujúcemu spôsobu platby, môžete ho zmeniť nižšie.',

  result_repeatPayment_title: 'Opakovanie pokusu o platbu',
  result_repeatPayment_info: 'Ak na platobnej bráne nastala technická chyba, je pravdepodobné, že bude opravená v krátkom čase. Môžete skúsiť vykonať platbu znovu napríklad o pól hodiny.',
  result_repeatPayment_button: 'Skúsiť platbu znovu',
  result_changePaymentType_title: 'Zmena spôsobu platby za prihlášku',
  result_registration_title: 'Vaša prihláška',

  result_changePaymentType_button_offline: 'Zmeniť typ platby',
  result_changePaymentType_button_online: 'Zaplatiť vybraným spôsobom',
  result_changePaymentType_selectType: 'Vyberte prosím nový typ platby',

  result_cancelRegistration_title: 'Stornovanie prihlášky',
  result_cancelRegistration_info: 'Ak ste sa rozhodli prihlášku nezaplatiť, stornujte ju prosím.',
  result_cancelRegistration_button: 'Stornovanať prihlášku',
  result_cancelRegistration_success: 'Vaša prihláška č. {0} bola stornovaná.',

  termsAndConditions_title: 'Všeobecné obchodné podmienky',
  termsAndConditions_info: 'Všeobecné obchodné podmienky organizácie {0} pre poskytovanie kurzov jogy.',

  organizationPage_title: 'Informácie o organizácii',
  organizationPage_basicInfo: 'Základné informácie',
  organizationPage_places: 'Miesta pôsobnosti',

  organization_name: 'Názov',
  organization_address: 'Adresa',
  organization_telephone: 'Telefón',
  organization_email: 'Email',
  organization_termsAndConditions: 'Obchodné podmienky',

  summary_orderButton: 'Objednávka s povinnosťou platby',
  summary_onlinePaymentInfo: 'Po odoslaní objednávky budete presmerovaní na platobnú bránu.',
  summary_submitBlock_title: 'Odoslanie objednávky',
  summary_afterRegistrationInfo: 'Doplňujúce informácie organizácie'
};
